import { render, staticRenderFns } from "./SystemRecommend.vue?vue&type=template&id=7919eca2&scoped=true"
import script from "./SystemRecommend.vue?vue&type=script&lang=js"
export * from "./SystemRecommend.vue?vue&type=script&lang=js"
import style0 from "./SystemRecommend.vue?vue&type=style&index=0&id=7919eca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7919eca2",
  null
  
)

export default component.exports